/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type UpdateConfigurationRequestBody = {
  /**
   * Shareable device-agent settings. Supported keys include platforms, update_channel, auto_update, pinned_target, blocked_versions, sync_interval_seconds, ai_scan_interval_seconds, disable_ai_scan, and disable_crash_reports. update_channel and blocked_versions can only be set by Speakeasy platform administrators; per-device identity and secret keys are forbidden, as is ai_scan, which Speakeasy injects from the organization's scan target list when serving agents.
   */
  config: { [k: string]: any };
};

/** @internal */
export type UpdateConfigurationRequestBody$Outbound = {
  config: { [k: string]: any };
};

/** @internal */
export const UpdateConfigurationRequestBody$outboundSchema: z.ZodMiniType<
  UpdateConfigurationRequestBody$Outbound,
  UpdateConfigurationRequestBody
> = z.object({
  config: z.record(z.string(), z.any()),
});

export function updateConfigurationRequestBodyToJSON(
  updateConfigurationRequestBody: UpdateConfigurationRequestBody,
): string {
  return JSON.stringify(
    UpdateConfigurationRequestBody$outboundSchema.parse(
      updateConfigurationRequestBody,
    ),
  );
}
